









import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Link extends Vue {
  @Prop({ required: true }) to!: string
  @Prop({ default: false }) exact!: boolean

  isExternalLink(routePath: string) {
    return /^(https?:|mailto:|tel:)/.test(routePath)
  }
}
